import { Amplify } from 'aws-amplify';

const userPoolId = process.env.REACT_APP_USER_POOL_ID;
const userPoolClientId = process.env.REACT_APP_USER_POOL_CLIENT_ID;

/**
 * False until the Cognito user pool is created and its IDs are in .env.
 * The app stays usable before then instead of crashing on every auth call.
 */
export const authConfigured = Boolean(userPoolId && userPoolClientId);

if (authConfigured) {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: userPoolId as string,
        userPoolClientId: userPoolClientId as string,
      },
    },
  });
}
